<template>
  <div id="app" :class="{ load: loading }">
    <div class="lock-mask" @click="close"></div>
    <div class="max-container">
      <div class="loading" :class="{load: loading}"></div>
      <img src="/static/images/icon_backtoTop.svg" alt="" class="backtoTop" :class="{ show: isShow }" v-scroll-to="{ element: '#app', duration: 1500 }">
      <div class="menu-toggle" @click="menuToggle()">
        <div class="menu-bar" :class="{ closeMenu: isClose }">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <!-- 選單 -->
      <menuSlide :class="{ closeMenu: isClose }"></menuSlide>

      <!-- 內容 -->
      <transition name="fade" mode="out-in" appear>
        <router-view />
      </transition>

      <!-- 頁尾 -->
      <footerView></footerView>
    </div>
  </div>
</template>

<script>
  import menuSlide from './components/menuSlide.vue';
  import footerView from './components/footerView.vue';
  export default {
    name: 'App',
    components: {
      menuSlide,
      footerView
    },
    data() {
      return {
        isClose: false,
        isShow: false,
        loading: false,
        window: {
          width: 0,
          hight: 0
        }
      }
    },
    methods: {
      menuToggle() {
        let vm = this;
        vm.isClose = !vm.isClose;
        $("body").toggleClass("open");
      },
      close(){
        let vm = this;
        vm.isClose = true;
        $("body").removeClass("open");
      },
      handleScroll(event) {
        // Any code to be executed when the window is scrolled
        let vm = this;
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        var s1_h = document.querySelector("#section1").clientHeight;
        if (scrollTop > 100) {
          vm.isShow = true
        } else {
          vm.isShow = false
        }
      },
      handleResize() {
        this.window.width = window.innerWidth;
        if (this.window.width < 992) {
          this.isClose = true
          $("body").removeClass("open");
        } else {
          this.isClose = false
        }
      }
    },
    created() {
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize)
    },
    watch: {
      $route(to, from) {
        this.window.width = window.innerWidth;
        if (this.window.width < 992) {
          this.loading = true
          this.isClose = true
          setTimeout(() => {
            this.loading = false
            $("body").removeClass("open");
          }, 1000)
        } else {
          this.loading = true
          this.isClose = true
          setTimeout(() => {
            this.loading = false
            this.isClose = false
          }, 1000)
        }
      },
    },
  }

</script>

<style lang="scss">
  @import 'src/assets/scss/common.scss';
  @import 'src/assets/scss/menuSlide.scss';
  @import 'src/assets/scss/navigation.scss';
  @import 'src/assets/scss/footer.scss';
  @import url(//fonts.googleapis.com/earlyaccess/notosanstc.css);

  #app {
    .lock-mask{
      @media screen and (max-width: 992px) {
        position: fixed;
        background: rgba(0, 0, 0, 0.8);
        width: 100%;
        height: 100vh;
        z-index: 2;
        transform: translateX(100%);
        transition: transform 0.5s linear;
      }
    }
    &.load {
      .menu-toggle {
        opacity: 0;
      }

      nav {
        opacity: 0;
      }
    }

  }

  body.open {
    overflow-y: hidden;

    #app {
      .lock-mask{
        transform: translateX(0);
      }
    }
  }

  @keyframes fade-out {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
    }
  }

  html,
  body {
  font-family: 'Noto Sans TC','微軟正黑體', sans-serif !important;
    font-size: 16px;
    color: black;
    background-color: black !important;
  }

  a:hover {
    text-decoration: none !important;
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  .btn:focus {
    box-shadow: none;
  }

  button:focus {
    outline: none;
  }

  .loading {
    position: fixed;
    width: 100%;
    bottom: 0;
    background-image: linear-gradient(to bottom, #000000, #454545);
    z-index: 999999;
  }

  .loading.load {
    animation: slide 1s linear forwards;
  }

  @keyframes slide {
    0% {
      bottom: 0;
      height: 0;
    }

    80% {
      opacity: 1;
      height: 100vh;
    }

    100% {
      opacity: 0;
      height: 100vh;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 1s;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }

  .max-container {
    position: relative;
    max-width: 1920px;
    margin: 0 auto;
  }

  .menu-toggle {
    position: relative;
    display: none;
    position: fixed;
    justify-content: center;
    align-items:center;
    width: 100%;
    height: 70px;
    background-color: black;
    z-index: 10000;
    opacity: 1;
    box-shadow: 0 0 12px 0px #2d3240a1;
    transition: opacity 0.5s linear 0.2s;
    cursor: pointer;
    @media screen and (max-width: 992px) {
      display: flex;
      height: 100px;
      width: 100px;
    }
    @media screen and (max-width: 768px) {
      height: 76px;
      width: 76px;
    }
    @media screen and (max-width: 576px){
      height: 70px;
      width: 70px;
    }
    .menu-bar{
      width: 25px;
      span{
        display: block;
        width: 100%;
        height: 3px;
        background-color: #00e1ff;
        margin:5px 0;
      }
      span:nth-child(2){
        width: 60%;
        transition: width 0.3s ease-in-out;
      }
      &.closeMenu{
        span:nth-child(2){
          width: 100%;
          transition: width 0.3s ease-in-out;
        }
      }
    }
  }

  .backtoTop {
    position: fixed;
    width: 100px;
    height: 100px;
    right: 200px;
    bottom: 96px;
    cursor: pointer;
    opacity: 0;
    transition: 0.6s;
    z-index: -1;

    @media screen and (max-width: 1500px) {
      width: 75px;
      height: 75px;
      bottom: 90px;
      right: 35px;
    }
    @media screen and (max-width: 768px) {
      width: 40px;
      height: 40px;
    }
    @media screen and (max-width: 576px) {
      width: 25px;
      height: 25px;
    }
  }

  .backtoTop.show {
    opacity: 1;
    z-index: 2;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue